"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var am4core = _interopRequireWildcard(require("@amcharts/amcharts4/core"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var amChartButton = function amChartButton(button) {
  var create = function create(id) {
    var amButton = new am4core.Button();
    amButton.id = id;
    return amButton;
  };

  var setDefaultStyles = function setDefaultStyles(theme) {
    button.background.fill = am4core.color(theme.colors.primaryLight);
    var hoverStyles = button.background.states.getKey('hover');
    hoverStyles.properties.fill = am4core.color(theme.colors.primary);
    button.background.states.getKey('down').properties.fill = am4core.color(theme.colors.primaryLight);
    button.background.fillOpacity = 1;
    button.background.strokeWidth = 0;
    button.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    var shadow = new am4core.DropShadowFilter();
    shadow.dx = 0;
    shadow.dy = 3;
    shadow.blur = 2;
    shadow.opacity = 0.3;
    shadow.color = am4core.color('#000');
    button.background.filters.push(shadow);
    return button;
  };

  return {
    create: create,
    setDefaultStyles: setDefaultStyles
  };
};

var _default = amChartButton;
exports["default"] = _default;